import { useEffect, useState } from "react";

import { PopulationBasedFundingPortfolioEvent } from "@/Portfolio/Models/PopulationBasedFunding/PopulationBasedFundingPortfolioEvent";
import { PopulationBasedFundingPortfolioActions } from "@/Portfolio/Services/PopulationBasedFundingPortfolioService";

function PopulationBasedFundingProposalCount(props: { underline: boolean }): JSX.Element {
    const [proposalCount, setProposalCount] = useState<number>();
    const populationBasedFundingEvents = React.useRef<PopulationBasedFundingPortfolioEvent[]>([]);

    useEffect(
        () => {
            const onPortfolioStoreChanged = async (): Promise<void> => {
                if (populationBasedFundingEvents.current !== portfolioStore?.populationBasedFundingPortfolioModel?.Data) {
                    populationBasedFundingEvents.current = portfolioStore?.populationBasedFundingPortfolioModel?.Data;

                    const count: number = await PopulationBasedFundingPortfolioActions.getActionableProposalCount();
                    setProposalCount(count);
                }
            };

            onPortfolioStoreChanged();

            const eventId = portfolioStore.AddChangeListener(onPortfolioStoreChanged, null);
            return () => portfolioStore.RemoveChangeListener(eventId);
        },
        []
    );

    let className = "text-white";
    if (props.underline)
        className += " underline";

    return <span className={className}> ({proposalCount}) </span>;
}

export { PopulationBasedFundingProposalCount };
